export enum ShiftCancelReason {
  ILLNESS = 'ILLNESS',
  ASSIGNMENT_ERROR = 'ASSIGNMENT_ERROR',
  PERSONAL_REASONS = 'PERSONAL_REASONS',
  OTHER = 'OTHER',
}
